module.exports = __webpack_public_path__ + "static/img/right_2.62d8f367.jpg";